import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
const testimonials = [['J.M.', 'Dance Fitness Instructor | Miami, USA', 'Preparing my classes used to take hours every week. Now I just open the system, choose the structure, and teach. My students notice the difference — and they keep coming back.'], ['L.R.', 'Certified Fitness Instructor | London, UK', 'The Choreography Library alone is worth the entire investment. Everything is organized by level and ready to use immediately. I have it open at every single class.'], ['C.T.', 'Fitness Studio Owner | Toronto, Canada', 'I teach groups with very different levels and this system finally gave me a framework I can trust to adapt every class without improvising.'], ['A.L.', 'Dance Fitness Instructor & Personal Trainer | Sydney, Australia', 'The 50 Complete Class Plans saved me countless hours of preparation. I wish I had found this in my very first year as an instructor.'], ['P.G.', 'Group Fitness Instructor | Dublin, Ireland', 'With the Choreography Library and Themed Classes, every week feels fresh — and my classes are fuller than ever.']];
export function ExtendedTestimonials() {
  return <section className="bg-soft px-4 py-20 sm:py-24" data-id="element-66">
      <div className="mx-auto max-w-6xl" data-id="element-67">
        <h2 className="mx-auto mb-12 max-w-3xl text-center font-display text-3xl font-bold text-navy sm:text-5xl" data-id="element-68">
          What other professional instructors are saying
        </h2>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-69">
          {testimonials.map(([initials, role, quote], index) => <motion.figure key={initials} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.07
        }} className="relative flex flex-col rounded-2xl border border-navy/15 bg-white p-7" data-id="element-70">
              <QuoteIcon className="absolute right-5 top-5 text-navy/10" size={40} data-id="element-71" />
              <div className="flex gap-1 text-orange" data-id="element-72">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} size={15} fill="currentColor" data-id="element-73" />)}
              </div>
              <blockquote className="mt-5 flex-1 text-sm italic leading-relaxed text-slate-600" data-id="element-74">
                “{quote}”
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-3" data-id="element-75">
                <span className="flex size-10 items-center justify-center rounded-full bg-navy text-xs font-bold text-white" data-id="element-76">
                  {initials}
                </span>
                <span className="text-xs text-navy" data-id="element-77">{role}</span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}